import React from 'react';
import {PersistGate} from 'redux-persist/integration/react';
import {ConnectedRouter} from 'connected-react-router'
import {Provider} from 'react-redux';

import Router from '../router';
import {store, history, persistor} from '../router/history';

export default () => (
    <Provider store={store}>
        <PersistGate loading={<div />} persistor={persistor}>
            <ConnectedRouter history={history}>
                <Router history={history} />
            </ConnectedRouter>
        </PersistGate>
    </Provider>
);
